/**
 * @generated SignedSource<<dd27c4f5cca99d0a28a0e52547b947fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentLiveTagContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleUtilsCheckHasLiveTagArticle">;
  readonly " $fragmentType": "contentLiveTagContent";
};
export type contentLiveTagContent$key = {
  readonly " $data"?: contentLiveTagContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentLiveTagContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentLiveTagContent",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "articleUtilsCheckHasLiveTagArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "flattenTypeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LiveArticle",
          "kind": "LinkedField",
          "name": "liveArticle",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "d2a4a10411ff9b8929eff4cb75ce8924";

export default node;
